import axios from "axios";
import ConstantList from "../appConfig";
import { getFormData } from "app/common/LocalFunction";

const API_PATH = ConstantList.API_EN_POINT + "/product-mapping";

// export const getAllCountry = () => axios.get(API_PATH + "/get-all-country");

export const pagingProductMapping = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getProductMappingById = (productMappingId) => axios.get(API_PATH + "/get-by-id/" + productMappingId);

export const saveProductMapping = productMapping => axios.post(API_PATH + '/save-or-update', productMapping);

export const markDeleteProductMapping = productMappingId => axios.delete(API_PATH + '/mark-delete/' + productMappingId)

export const deleteProductMapping = productMappingId => axios.delete(API_PATH + '/delete/' + productMappingId)

export const importExcelMapping = (file) => {
    let formData = getFormData({ file: file });
    return axios({
        url: API_PATH + '/import-excel',
        headers: {
            "Content-Type": "multipart/form-data",
        },
        method: "POST",
        responseType: "blob",
        data: formData,
    })
}

